module.exports = __webpack_public_path__ + "static/assets/5293fab4f20712e805d99ce816e4fac7.png";